import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  cover: string;
  rating: number;
  category: string;
  chapters: number;
  views: number;
  status: string;
  tags: string[];
  updateDate?: string;
}

export default function ComicCard({ id, title, author, cover, rating, category, chapters, views, status, tags, updateDate }: ComicCardProps) {
  const viewsText = views >= 10000 ? `${(views / 10000).toFixed(1)}万` : views.toString();

  return (
    <Link
      to={`/comic/${id}`}
      className="group block bg-white rounded-lg overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
      data-product-shop
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2 flex flex-wrap gap-1">
          <span className="px-2 py-0.5 text-[10px] font-medium rounded-full bg-primary-500 text-white whitespace-nowrap">
            {rating}
          </span>
          {status === '已完结' && (
            <span className="px-2 py-0.5 text-[10px] font-medium rounded-full bg-accent-500 text-white whitespace-nowrap">
              完结
            </span>
          )}
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3 pt-8">
          <span className="text-xs text-white/80">{chapters}话</span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
          {title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 truncate">{author}</p>
        <div className="flex items-center gap-3 mt-2">
          <span className="text-xs text-foreground-400 flex items-center gap-1">
            <i className="ri-eye-line text-[11px] w-3.5 h-3.5 flex items-center justify-center"></i>
            {viewsText}
          </span>
          <div className="flex flex-wrap gap-1">
            {tags.slice(0, 2).map((tag) => (
              <span key={tag} className="px-1.5 py-0.5 text-[10px] rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </Link>
  );
}